import { TimeOffRequest } from '@/modules/time-off/types/time-off-request';
import { TimeOffStatus } from '@/modules/time-off/types/time-off-status';

import { TimeOffRequestSummaryStatus, TimeOffSummaryItem } from '../types/time-tracking';

/**
 * Canonical ordering for time-off across every view: PENDING first (top),
 * APPROVED last (bottom). Centralised here so the week strip, week expanded
 * row, day card, month "time offs" card and month calendar cell all share one
 * source of truth instead of re-implementing the comparator.
 *
 * Returns a new array; the inputs are not mutated.
 */

const summaryRank = (status: TimeOffRequestSummaryStatus): number =>
  status === TimeOffRequestSummaryStatus.PENDING ? 0 : 1;

const requestRank = (status: TimeOffStatus): number => (status === TimeOffStatus.Pending ? 0 : 1);

/** Comparator (PENDING first) for any items keyed by a request status. */
export const byTimeOffRequestStatus =
  <T>(getStatus: (item: T) => TimeOffStatus) =>
  (a: T, b: T): number =>
    requestRank(getStatus(a)) - requestRank(getStatus(b));

export const sortTimeOffSummaryItems = (items: TimeOffSummaryItem[]): TimeOffSummaryItem[] =>
  [...items].sort((a, b) => summaryRank(a.status) - summaryRank(b.status));

export const sortTimeOffRequests = (requests: TimeOffRequest[]): TimeOffRequest[] =>
  [...requests].sort(byTimeOffRequestStatus(request => request.status));
